import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = 'GBP') {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  }).format(value || 0);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStageColor(stage) {
  const colors = {
    intake: 'bg-slate-100 text-slate-700',
    matching: 'bg-blue-100 text-blue-700',
    qa: 'bg-amber-100 text-amber-700',
    pending_approval: 'bg-amber-100 text-amber-700',
    approved: 'bg-emerald-100 text-emerald-700',
    filed: 'bg-green-100 text-green-700',
    closed: 'bg-gray-100 text-gray-700',
    exception: 'bg-red-100 text-red-700',
  };
  return colors[stage] || 'bg-gray-100 text-gray-700';
}

export function getRoleLabel(role) {
  const labels = {
    client_admin: 'Client Admin',
    viewer: 'Viewer',
    meridian_operator: 'Operator',
    meridian_approver: 'Approver',
    '3pl_operator': '3PL Operator',
  };
  return labels[role] || role;
}

export function getEvidenceTypeLabel(type) {
  const labels = {
    commercial_invoice: 'Commercial Invoice',
    export_declaration: 'Export Declaration',
    return_label: 'Return Label',
    c79_certificate: 'C79 Certificate',
    proof_of_return: 'Proof of Return',
    condition_photo_front: 'Photo (Front)',
    condition_photo_back: 'Photo (Back)',
    condition_photo_detail: 'Photo (Detail)',
    other: 'Other',
  };
  return labels[type] || type;
}

export function truncate(str, length = 30) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export const apiError = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d?.message) return d.message;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback || err?.message || 'Something went wrong';
};

const STAGE_LABELS = {
  intake: 'Intake', data_intake: 'Intake', open: 'Intake', new: 'Intake', draft: 'Intake',
  matching: 'Matching', linkage: 'Linkage pending', forensic_matching: 'Matching',
  in_progress: 'In progress', active: 'In progress', claim_building: 'In progress',
  qa: 'Approval pending', qa_review: 'Approval pending', pending_approval: 'Approval pending',
  approved: 'Approved', stage_4_ready: 'Approved', filed: 'Filed', submitted: 'Filed',
  closed: 'Closed', exception: 'Exception', archived: 'Archived', rejected: 'Rejected', rework: 'Rework',
};
export const getStageLabel = (stage) => STAGE_LABELS[String(stage || '').toLowerCase()]
  || String(stage || 'Unknown').replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

// Accessible-name fallback for icon-only / unlabeled controls, derived from title or data-testid.
export const a11yName = (props) => {
  if (props['aria-label'] || props['aria-labelledby']) return undefined;
  const src = props.title || props['data-testid'];
  if (!src) return undefined;
  const t = String(src).replace(/[-_]+(btn|button|trigger|select)$/i, '').replace(/[-_]+/g, ' ').trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
};
